module.exports = new __parcel__URL__("machines_nine_lives_lounge_level_1.ebee7856.png").toString();